import { Avatar, Text, theme } from '@hhgtech/hhg-components'

import { SpotlightExpert } from 'interfaces/types'

import {
  StyledExpertAvatar,
  StyledExpertInfo,
  StyledSpotlightExpert,
} from './index.styled'

export type Props = {
  isMobile?: boolean
  expertInfo: SpotlightExpert
  isSingleExpert: boolean
}

const SpotlightsExpert = ({ isMobile, expertInfo, isSingleExpert }: Props) => {
  return (
    <StyledSpotlightExpert data-is-single-expert={isSingleExpert}>
      <StyledExpertAvatar>
        <a
          href={expertInfo?.profileUrl || '#'}
          style={{ textDecoration: 'none' }}
        >
          <Avatar
            type="rounded"
            avatarUrl={expertInfo?.avatarThumbnail}
            size={isMobile ? 'xl' : 'xxxl'}
            firstLetter={
              expertInfo?.displayName && expertInfo?.displayName?.length > 0
                ? expertInfo?.displayName?.[0].toUpperCase()
                : 'A'
            }
            backgroundColor={theme.colors.secondaryBase}
            className="avatar"
          />
          {expertInfo?.role && (
            <img
              src={`/images/reviewer-${expertInfo.role}.svg`}
              alt="badge"
              className="badge"
              loading="lazy"
            />
          )}
        </a>
      </StyledExpertAvatar>
      <StyledExpertInfo data-is-single-expert={isSingleExpert}>
        <Text size="sm" className="name" color="#262626">
          {expertInfo?.displayName}
        </Text>
        {!isMobile && (
          <Text size="xs" color="#404040" key={0}>
            {expertInfo?.specialty}
          </Text>
        )}
      </StyledExpertInfo>
    </StyledSpotlightExpert>
  )
}

export { SpotlightsExpert }
